import { useTheme } from "@material-ui/core";
import { ReportProblemOutlined } from "@material-ui/icons";


const WarningIcon = ({style, ...props}: React.ComponentProps<typeof ReportProblemOutlined>) => {
    const theme = useTheme();
    return (
        <ReportProblemOutlined style={{color: theme.palette.warning.main, ...style}} fontSize='small' {...props} />
    )
}

export default WarningIcon;